import { Fragment, useContext, useEffect, useState } from 'react';
import { Card, CardBody, CardFooter, CardHeader } from '@/components/bootstrap/TemporaryReactstrapCompatibilityLayer';
import UIContext from '../../contexts/ui/UIContext';
import Button from '../layout/Button';


const AddGlobalUser = ({ cancelHandler, saveHandler }) => {
  const { setInfo, addNotification } = useContext(UIContext);

  const re =
    /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

    const user = {
      email: '',
      role: 1
    }

  const initialState = {
    email: {
      value: user.email ?? '',
      touched: false,
      validate: function (text) {
        return re.test(text);
      },
      isValid: false,
      placeholder: '',
    },
    role: {
      value: user.role ?? 0,
      touched: true,
      validate: function () {
        return true;
      },
      isValid: true,
      placeholder: '',
    },
  };

  const [userState, setUserState] = useState(initialState);

  const isStateValid = Object.values(userState)
    .map((entry) => entry.isValid)
    .every((isValid) => isValid);

  const onChange = (event) => {
    event.persist();

    const key = event.currentTarget.name;
    const value = event.currentTarget.value;
    setUserState((prev) => ({
      ...prev,
      [key]: {
        ...userState[key],
        value,
        isValid: userState[key]?.validate(value),
        touched: true,
      },
    }));
  };

  const createUser = () => {
    const userProperties = Object.entries(userState).reduce((acc, [key, valueObject]) => {
      return { ...acc, [key]: valueObject.value };
    }, {});

    return userProperties;
  };


  const handleSave = async () => {
    await saveHandler(createUser());
    addNotification("Successfully added global admin.", 'success');
    reset();
    setInfo('Global User Management');

  };

  const reset = () => {
    setUserState(initialState);
  };

  useEffect(() => {
  }, [userState]);


  return (
    <Card className='seed-card'>
      <CardHeader className='seed-card-body'>
        <input
          className='h4-input seed-property-input-field header-input'
          type='text'
          minLength='3'
          value='Add Global Admin'
          onChange={onChange}
          name='name'
          id='name'
          placeholder=''
          disabled={true}
        />
      </CardHeader>
      <CardBody>
        <Fragment>
          <div className='card-body-input-row'>
            <label className='input-label' htmlFor='email'>Email&nbsp;</label>
            <input
              // type='textarea'
              type='text'
              // wrap='hard'
              name='email'
              className={
                userState.email.isValid || !userState.email.touched
                  ? 'seed-property-input-field italic mb-4'
                  : 'seed-property-input-field italic invalid-field mb-4'
              }
              minLength='3'
              value={userState.email.value}
              placeholder={userState.email.placeholder}
              onChange={onChange}
              disabled={false}
              // style={{ whiteSpace: 'pre-wrap' }}
            />
            <Button
              clickHandler={() => {}}
              label={'Global Admin'}
              disabled={true}
              icon={"fas fa-globe"}
            />
          </div>
        </Fragment>
      </CardBody>
      <CardFooter>
      <div className='card-button seed-card-footer'>
        <Fragment>
          <Button className='seed-card-btn' label='Cancel' clickHandler={cancelHandler} />
          <Button className='seed-card-btn' label='Create' clickHandler={handleSave} disabled={!isStateValid} />
        </Fragment>
      </div>
      </CardFooter>

    </Card>
  );
};
export default AddGlobalUser;
